<button class="btn btn-prev" [ngClass]="{ 'btn-disabled': disablePrevious }"
  (click)="previous.emit()" [disabled]="disablePrevious">
    <i class="fal fa-angle-left"></i>
</button>

<ng-content></ng-content>

<button class="btn btn-next" [ngClass]="{ 'btn-disabled': disableNext }"
  (click)="next.emit()" [disabled]="disableNext">
    <i class="fal fa-angle-right"></i>
</button>
